import {
  BID_MODAL_CREATE_BID,
  BID_MODAL_RESET_BID,
  BID_MODAL_DELETE_BID,
  BID_MODAL_RESOLVE_OFFER,
  BID_MAX_MODAL_CREATE_BID
} from 'constants/action-types';

const initialState = {
  bidSuccess: null,
  deleteSuccess: null,
  resolveSuccess: null,
  createBidError: null,
  isBuyNow: false,
  buyNowPrice: null,
  isAccepted: null,
  bidMaxSuccess: null,
  isLoading: false
};

export const jewelBid = (state = initialState, action) => {
  switch (action.type) {
    case BID_MODAL_CREATE_BID.pending:
    case BID_MODAL_DELETE_BID.pending:
      return { ...initialState, isLoading: true };
    case BID_MODAL_CREATE_BID.error:
      return {
        ...state,
        bidSuccess: false,
        openModalPlace: action.meta.source,
        createBidError: action.payload,
        isLoading: false
      };
    case BID_MODAL_CREATE_BID.success:
      return {
        ...state,
        bidSuccess: true,
        openModalPlace: action.meta.source,
        isBuyNow: action.meta.isBuyNow,
        buyNowPrice: action.meta.isBuyNow ? action.payload.bidPrice : null,
        listingId: action.meta.isBuyNow ? action.payload.listingId : null,
        isLoading: false
      };
    case BID_MAX_MODAL_CREATE_BID.error:
      return {
        ...state,
        bidSuccess: false,
        bidMaxSuccess: false,
        openModalPlace: action.meta.source,
        createBidError: action.payload,
        isLoading: false
      };
    case BID_MAX_MODAL_CREATE_BID.success:
      return {
        ...state,
        bidSuccess: true,
        bidMaxSuccess: true,
        openModalPlace: action.meta.source,
        isBuyNow: action.meta.isBuyNow,
        buyNowPrice: action.meta.isBuyNow ? action.payload.bidPrice : null,
        listingId: action.meta.isBuyNow ? action.payload.listingId : null,
        isLoading: false
      };
    case BID_MODAL_DELETE_BID.success:
      return {
        ...state,
        deleteSuccess: true,
        isLoading: false
      };
    case BID_MODAL_RESOLVE_OFFER.success:
      return {
        ...state,
        resolveSuccess: true,
        isAccepted: action.meta.isAccepted,
        isLoading: false
      };
    case BID_MODAL_DELETE_BID.error:
      return { ...state, deleteSuccess: false, isLoading: false };
    case BID_MODAL_RESET_BID:
      return { ...initialState };
    default:
      return state;
  }
};
